import { gql } from '@apollo/client';
import { client } from '..';
import {
  ArticleFormat,
  SuggestArticlesQuery,
  SuggestArticlesQueryVariables,
} from '../../__generated__/queries-web';
import { useGetArticle } from './articles.web.graphql';

const SUGGEST_ARTICLE_QUERY = gql`
  query SuggestArticles(
    $first: UnsignedInt!
    $like: ArticleLikeInput!
    $where: ArticleFilterSearchInput
  ) {
    searchArticles(first: $first, like: $like, where: $where) {
      id
      title
      status
      body
      createdAt
      publishedAt
      editedAt
      brandKey
      format
      medias
      canonical
      pushCount
      refererCount
      live {
        postCount
      }
      categories(first: 2, orderBy: order_ASC) {
        order
        category {
          id
          title
        }
      }
      channels(first: 1) {
        order
        category {
          id
          title
        }
      }
      creator {
        name
      }
      urls(first: 1, orderBy: order_ASC) {
        origin
        path
      }
      qualifiers(first: 100) {
        order
        qualifier {
          id
          title
        }
      }
      lockedAt
      lockedBy {
        id
        name
        email
        avatarUrl
      }
      events(first: 10) {
        category {
          id
          title
        }
        order
      }
      qualifiers(first: 100) {
        qualifier {
          id
          title
        }
      }
      histories(first: 100, orderBy: createdAt_ASC) {
        user {
          ... on OneUser {
            name
          }
        }
      }
      authors(first: 1) {
        author {
          id
          name
          avatarUrl
        }
      }
    }
  }
`;

export const useSuggestArticleQuery = (
  data: NonNullable<ReturnType<typeof useGetArticle>>['data'] | undefined,
) => ({
  suggestQuery:
    data &&
    (async (format: ArticleFormat) => {
      const suggestQueryItems =
        (
          await client.query<
            SuggestArticlesQuery,
            SuggestArticlesQueryVariables
          >({
            fetchPolicy: 'no-cache',
            query: SUGGEST_ARTICLE_QUERY,
            variables: {
              first: 2,
              where: {
                format,
              },
              like: {
                title: data.article?.title,
              },
            },
          })
        ).data.searchArticles || [];

      return suggestQueryItems;
    }),
});
